export default {
      id: "color_milk-usage",
      viewBox: "0 0 106.2 105.5",
      url: __webpack_public_path__ + "sprite.svg#color_milk",
      toString: function () {
        return this.url;
      }
    }